module.exports = __webpack_public_path__ + "img/img80.a8aa4f04.png";